/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendMonthlyTransactionsToLegalCommand } from '../../models/send-monthly-transactions-to-legal-command';
import { Success } from '../../models/success';

export interface SendMonthlyDepositsAsync$Plain$Params {
      body?: SendMonthlyTransactionsToLegalCommand
}

export function sendMonthlyDepositsAsync$Plain(http: HttpClient, rootUrl: string, params?: SendMonthlyDepositsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Success>> {
  const rb = new RequestBuilder(rootUrl, sendMonthlyDepositsAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Success>;
    })
  );
}

sendMonthlyDepositsAsync$Plain.PATH = '/api/report/legal/monthly-deposits';
